import { Biscuit, isViewVisible } from '../utils'

const ContingentsControllerAccessBarMap: () => {
    locations: { url: string; icon: string; isAccessible: boolean };
    all_times: { url: string; icon: string; isAccessible: boolean };
    opening_times: { url: string; icon: string; isAccessible: boolean };
    contingents: { url: string; icon: string; isAccessible: boolean };
    products: { url: string; icon: string; isAccessible: boolean };
    pricetariffs: { url: string; icon: string; isAccessible: boolean };
    frontendChanges: { url: string; icon: string; isAccessible: boolean };
    abonnements?: { url: string; icon: string; isAccessible: boolean };
    facilities: { url: string; icon: string; isAccessible: boolean }
} = () : {
    locations: { url: string; icon: string; isAccessible: boolean };
    all_times: { url: string; icon: string; isAccessible: boolean };
    opening_times: { url: string; icon: string; isAccessible: boolean };
    contingents: { url: string; icon: string; isAccessible: boolean };
    products: { url: string; icon: string; isAccessible: boolean };
    pricetariffs: { url: string; icon: string; isAccessible: boolean };
    frontendChanges: { url: string; icon: string; isAccessible: boolean };
    abonnements?: { url: string; icon: string; isAccessible: boolean };
    facilities: { url: string; icon: string; isAccessible: boolean }
} => {

    let isFacilityClient:boolean = false;
    if ((Biscuit.get('client.hasFacilities')) === 'true') {
        isFacilityClient = true;
    }
    let useUsageTypes:boolean = false;
    if(Biscuit.get('client.show_usage_types') === 'true'){
        useUsageTypes=true;
    }
    let superUser:boolean = false;
    if(Biscuit.get('user.is_superuser') === 'true'){
        superUser=true;
    }

    return {
        locations: {
            url: '/locations',
            icon: 'fi fi-marker',
            isAccessible: isViewVisible('locations','contingents')
        },
        all_times: {
            url: '/check_in_periods',
            icon: 'fi fi-clock',
            isAccessible: isViewVisible('check_in_periods','contingents') && useUsageTypes
        },
        opening_times: {
            url: '/check_in_periods',
            icon: 'fi fi-clock',
            isAccessible: isViewVisible('check_in_periods','contingents') && !useUsageTypes
        },
        contingents: {
            url: '/contingents',
            icon: 'fi fi-list',
            isAccessible: isViewVisible('contingents','contingents')
        },
        products: {
            url: '/products',
            icon: 'fi fi-list',
            isAccessible: isViewVisible('products','contingents')
        },
        pricetariffs: {
            url: '/pricetariffs',
            icon: 'fi fi-euro',
            isAccessible: isViewVisible('pricetariffs','contingents')
        },
        abonnements: {
            url: '/abonnements',
            icon: 'fi fi-euro',
            isAccessible: isViewVisible('abonnements','contingents') && superUser
        },
        frontendChanges:{
            url: '/frontend_locations/jobs',
            icon: 'fi fi-widget',
            isAccessible: (Biscuit.get('user.role') === 'admin' && (Biscuit.get('client.isVehicleOwner') === 'true' || Biscuit.get('client.hasParkingLots') === 'true'))
        },
        facilities: {
            url: '/facilities',
            icon: 'fi fi-list',
            isAccessible: isViewVisible('facilities','contingents') && isFacilityClient
        },


       /* pricediscounts: {
            url: '/pricediscounts',
            icon: 'fi fi-euro',
            isAccessible: isViewVisible('pricediscounts','contingents')
        },*/
       /* contingentPlans: {
            url: '/contingent_plans',
            icon: 'fi fi-widget',
            isAccessible: (Biscuit.get('user.role') === 'admin' && Biscuit.get('client.isVehicleOwner') === 'true')
        },
        networkPlans: {
            url: '/network_plans',
            icon: 'fi fi-target',
            isAccessible: (Biscuit.get('user.role') === 'admin' && Biscuit.get('client.isVehicleOwner') === 'true')
        }*/

    };
}

export default ContingentsControllerAccessBarMap;